import * as tf from '@tensorflow/tfjs';
import { model } from './FileUploader';

const assert = require('assert');
const math = require('mathjs'); //install using "npm install mathjs"

export async function timerFired(data) {
    // console.log("timerFired(data) is called....")

    // console.log("Check data.agent_goals : " + data.agent_goals);
    // console.log("Check data.agent_positions : " + data.agent_positions);
    if(math.deepEqual(data.agent_positions, data.agent_goals)) {
        data.paused = true;
        console.log("game is paused")
    }

    if(!data.paused) {

        let totalNumOfAgents = math.count(data.agent_positions)/2;
        // console.log("totalNumOfAgents : " + totalNumOfAgents);
        for (let i = 0; i < totalNumOfAgents; i++) {
            // console.log("i : " + i);
            let ID = i + 1;
            let [observation_0, observation_1] = observe(data, ID, data.GOALS);

            // console.log("from timerFired observation_0: " + observation_0);
            // console.log("from timerFired observation_1: " + observation_1);
            // console.log("data.rnn_states : " + data.rnn_states);
            // console.log("agentRnnState : " + math.subset(data.rnn_states, math.index(ID-1,math.range(0,2),math.range(0,1),math.range(0,512))));
            
            // console.log("Running model....")

            let agentRnnState = math.subset(data.rnn_states, math.index(ID-1,math.range(0,2),math.range(0,1),math.range(0,512)));
            

            let [c_init, h_init, a_dist,v,lstm_c,lstm_h,blocking] = await run(data, agentRnnState, observation_0, observation_1);

            // c_init = math.matrix([c_init])
            // h_init = math.matrix([h_init])
            // a_dist = math.matrix([a_dist])
            // v = math.matrix([v])
            // lstm_c = math.matrix([lstm_c])
            // lstm_h = math.matrix([lstm_h])
            // blocking = math.matrix([blocking])

            // console.log("after c_init : " + c_init);
            // console.log("after h_init : " + h_init);
            // console.log("after policy/ a_dist  : " + a_dist);
            // console.log("after value / v : " + v);
            // console.log("after lstm_c : " + lstm_c);
            // console.log("after lstm_h : " + lstm_h);
            // console.log("after blocking : " + blocking);

            data.state_init = math.matrix([[c_init], [h_init]]);
            // console.log("after data.state_init : " + data.state_init)

            // WORK FROM HERE ONWARDS

            //agentRnnState = (lstm_c[:1, :], lstm_h[:1, :])  //Added step because state_out is not a dtype                                     
            // let a = math.matrix([lstm_c.slice(0, 1).map(row => row.slice(0))]);
            // console.log("after a sliced lstm_c: " + a)
            // let b = math.matrix([lstm_h.slice(0, 1).map(row => row.slice(0))]);
            // console.log("after b sliced lstm_h: " + b)
            // agentRnnState = math.matrix([a,b]);

            // agentRnnState = math.matrix([lstm_c,lstm_h]); 

            // console.log("after agentRnnState: " + agentRnnState)
            // console.log("matrix size agentRnnState.size() : " + agentRnnState.size());

            //data.rnn_states[ID-1]=agentRnnState
            
            // console.log(`before data.rnn_states for agent - ${ID-1}: ` + data.rnn_states);
            // console.log("matrix size data.rnn_states.size() : " + data.rnn_states.size());

            data.rnn_states = math.subset(data.rnn_states, math.index(ID-1, 0, 0, math.range(0,512)), lstm_c); 
            data.rnn_states = math.subset(data.rnn_states, math.index(ID-1, 1, 0, math.range(0,512)), lstm_h); 
            
            // console.log(`after data.rnn_states for agent - ${ID-1}: ` + data.rnn_states);
            
            //data.blocking_confidences[ID-1]=np.ravel(blocking)[0]
            // console.log("before blocking : " + blocking)
            let flattened_blocking = math.flatten(blocking);
            // console.log("after flattened blocking : " + flattened_blocking)

            // console.log("before blocking_confidences : " + data.blocking_confidences);
            data.blocking_confidences = math.subset(data.blocking_confidences, math.index(ID-1), flattened_blocking[0]); 
            // console.log("after data.blocking_confidences : " + data.blocking_confidences);

            //action=np.argmax(a_dist)
            // console.log("before a_dist : " + a_dist);
            // console.log("math.max(a_dist) : " + math.max(a_dist));
            let flattened_action = math.flatten(a_dist).toArray();  // For multidimensional Array need flatten first
            // console.log("flattened_action : " + flattened_action);
            let action = flattened_action.indexOf(math.max(a_dist));  
            // console.log("after action : " + action);

            //dx,dy = getDir(action);
            let [dx,dy] = getDir(data, action);
            // console.log("dx : " + dx);
            // console.log("dy : " + dy);

            //ax,ay =data.agent_positions[ID-1]
            let ax = math.subset(data.agent_positions, math.index(ID-1, 0));
            let ay = math.subset(data.agent_positions, math.index(ID-1, 1));
            // console.log("ax : " + ax);
            // console.log("ay : " + ay);

            if(ax + dx >= data.size || ax + dx < 0 || ay + dy >= data.size || ay + dy < 0){
                // console.log("continue 1")
                continue;
            }
            if(math.subset(data.state, math.index( ax + dx , ay + dy )) < 0) { // collide with static obstacle
                // console.log("continue 2")
                continue;
            }
            if(math.subset(data.state, math.index( ax + dx , ay + dy )) > 0) { // collide with robot
                // console.log("continue 3")
                continue;
            }

            // console.log("Get pass all continue");

            // No collision: we can carry out the action

            // console.log("debug before data.state : " + data.state);

            //data.state[ax,ay] = 0
            data.state = math.subset(data.state, math.index(ax,ay), 0); 
            // console.log("after data.state : " + data.state);

            //data.state[ax+dx,ay+dy] = ID;
            data.state = math.subset(data.state, math.index(ax+dx,ay+dy), ID);
            // console.log("after data.state : " + data.state);

            // console.log("debug after data.state : " + data.state);

            //data.agent_positions[ID-1] = (ax+dx,ay+dy)  
            // WORK ON THIS PART!

            // console.log("debug before data.agent_positions : " + data.agent_positions);

            // console.log(`debug prevAgentPos for agent ${ID} : `  + [ax,ay]);
            let newAgentPos = math.matrix([ax+dx,ay+dy]);
            // console.log(`debug newAgentPos for agent ${ID} : `  + newAgentPos);
            data.agent_positions = math.subset(data.agent_positions, math.index(ID-1, math.range(0,2)), newAgentPos);
            // console.log(`debug after data.agent_positions for agent ${ID} : ` + data.agent_positions);

        }
    }
}

async function run(data, agentRnnState, observation_0, observation_1){

    // console.log("Loading variables...")
    
    // const c_in = tf.zeros([1, 512]);
    // console.log("c_in /agentRnnState[1] : " + c_in);
    // const h_in = tf.zeros([1, 512]);
    // console.log("h_in /agentRnnState[0]: " + h_in);
    // const goal_pos = tf.zeros([1, 3]);
    // console.log("goal_pos / observation[1] : " + goal_pos);
    // const inputs = tf.zeros([1,4,10,10]);
    // console.log("inputs / observation[0]: " + inputs);

    // console.log("agentRnnState : " + agentRnnState);
    // console.log("observation_0 : " + observation_0); 
    // console.log("observation_1 : " + observation_1); 
    
    //  agentRnnState : [[[[1, ..... , 512]] , [[1, ..... , 512]]]]
    // [agentRnnState[0]] :  [[1, ..... , 512]]
    // [agentRnnState[0]] :  [[1, ..... , 512]]
    // [observation[0]] :  [[0, 0, 0.0]]
    // [observation[1]] :  [[0, 0, 0.0]]

    // console.log("Loading model....")
    // const path = 'https://savedmodeljs.s3.ap-southeast-1.amazonaws.com/model.json';
    // const path = 'http://localhost:3000/23efdc04-1034-49a3-9d31-0db2b7d4a110';
    // const model = await tf.loadGraphModel(path);
    // const model = await tf.loadGraphModel(path, { fetchFunc: () => fetch(path, { mode: 'no-cors' }) });

    // Run this once instead
    // const path = data.model_path;
    // let model = await tf.loadGraphModel(path);
    // console.log("Model loaded successfully");

    let c_in = math.subset(agentRnnState, math.index(0, 1, 0, math.range(0,512)));
    c_in = math.reshape(c_in, [1,512]);
    // console.log("variable c_in : " + c_in)
    // console.log("shape of c_in : " + c_in.size())
    c_in = tf.tensor(c_in.toArray(), c_in.size());
    // console.log("tf variable c_in : " + c_in)
    
    let h_in = math.subset(agentRnnState, math.index(0, 0, 0, math.range(0,512)));
    h_in = math.reshape(h_in, [1,512]);
    // console.log("variable h_in : " + h_in)
    // console.log("shape of h_in : " + h_in.size())
    h_in = tf.tensor(h_in.toArray(), h_in.size());
    // console.log("tf variable h_in : " + h_in)
    
    let goal_pos = observation_1;
    // console.log("variable goal_pos : " + goal_pos)
    // console.log("shape of goal_pos : " + goal_pos.size())
    goal_pos = tf.tensor(goal_pos.toArray(), goal_pos.size());
    // console.log("tf variable goal_pos : " + goal_pos)

    let inputs = observation_0;
    // console.log("shape of inputs : " + inputs.size())
    // console.log("variable inputs : " + inputs)
    inputs = tf.tensor(inputs.toArray(), inputs.size());
    // console.log("tf variable inputs : " + inputs)

    const outputs = ['global/qvalues/c_init:0', 'global/qvalues/h_init:0', 'global/qvalues/policy:0', 'global/qvalues/value:0', 'global/qvalues/lstm_c:0', 'global/qvalues/lstm_h:0', 'global/qvalues/blocking:0']

    // console.log("getting results...");

    let inputShape = model.inputs[0].shape;
    let inputType = model.inputs[0].dtype;
    let inputName = model.inputs[0].name;
    // console.log(`Input 0 shape: ${inputShape}`);
    // console.log(`Input 0 type: ${inputType}`);
    // console.log(`Input 0 Name: ${inputName}`);

    inputShape = model.inputs[1].shape;
    inputType = model.inputs[1].dtype;
    inputName = model.inputs[1].name;
    // console.log(`Input 1 shape: ${inputShape}`);
    // console.log(`Input 1 type: ${inputType}`);
    // console.log(`Input 1 Name: ${inputName}`);

    inputShape = model.inputs[2].shape;
    inputType = model.inputs[2].dtype;
    inputName = model.inputs[2].name;
    // console.log(`Input 2 shape: ${inputShape}`);
    // console.log(`Input 2 type: ${inputType}`);
    // console.log(`Input 2 Name: ${inputName}`);

    inputShape = model.inputs[3].shape;
    inputType = model.inputs[3].dtype;
    inputName = model.inputs[3].name;
    // console.log(`Input 3 shape: ${inputShape}`);
    // console.log(`Input 3 type: ${inputType}`);
    // console.log(`Input 3 Name: ${inputName}`);

    let result;
    try{
        // console.log("awaiting results...");
        result = await model.executeAsync([c_in, h_in, goal_pos, inputs], outputs);
        // console.log("RESULT RECEIVED...");
        // console.log("Result: " + result);
    } catch(err) {
        console.log("RESULT ERROR : " + err);
        data.paused = true;
    }
    
    const c_init = math.matrix(Array.from(await result[0].data()));
    // console.log("c_init : " + c_init);
    const h_init = math.matrix(Array.from(await result[1].data()));
    // console.log("h_init : " + h_init);
    const policy = math.matrix(Array.from(await result[2].data()));
    // console.log("policy : " + policy);
    const value = math.matrix(Array.from(await result[3].data()));
    // console.log("value : " + value);
    const lstm_c = math.matrix(Array.from(await result[4].data()));
    // console.log("lstm_c : " + lstm_c);
    const lstm_h = math.matrix(Array.from(await result[5].data()));
    // console.log("lstm_h : " + lstm_h);
    const blocking = math.matrix(Array.from(await result[6].data()));
    // console.log("blocking : " + blocking);

    return [c_init, h_init, policy, value, lstm_c, lstm_h, blocking];
}


function observe(data, agent_id, goals) {

    //assert(agent_id>0)
    assert.ok(agent_id > 0, `Expected agent_id to be greater than 0, but got ${agent_id}`);

    //  Math.floor(x / y) is JS equivalent of ( x // y ) in python

    // top_left=(data.agent_positions[agent_id-1][0]-10//2, data.agent_positions[agent_id-1][1]-10//2)
    let a = math.subset(data.agent_positions, math.index(agent_id-1, 0)) - Math.floor(10 / 2);
    // console.log(`for agent ${agent_id} : a is ${a}`)
    let b = math.subset(data.agent_positions, math.index(agent_id-1, 1)) - Math.floor(10 / 2);
    // console.log(`for agent ${agent_id} : b is ${b}`)

    let top_left = math.matrix([a,b])
    // console.log(`for agent ${agent_id} : top_left is ${top_left}`)

    //bottom_right=(top_left[0]+10,top_left[1]+10)   
    let bottom_right = math.matrix([(math.subset(top_left, math.index(0)) + 10), (math.subset(top_left, math.index(1)) + 10)])
    // console.log(`for agent ${agent_id} : bottom_right is ${bottom_right}`)


    // obs_shape=(10,10)
    // goal_map             = np.zeros(obs_shape)
    // poss_map             = np.zeros(obs_shape)
    // obs_map              = np.zeros(obs_shape)
    // goals_map            = np.zeros(obs_shape)

    let goal_map             = math.zeros(10,10)
    let poss_map             = math.zeros(10,10)
    let obs_map              = math.zeros(10,10)
    let goals_map            = math.zeros(10,10)

    // visible_agents = []
    let visible_agents=math.matrix([[]]);

    let topLeft_0 = math.subset(top_left, math.index(0));
    let topLeft_1 = math.subset(top_left, math.index(1));
    // console.log(`for agent ${agent_id} : topLeft_0 is ${topLeft_0}`)
    // console.log(`for agent ${agent_id} : topLeft_1 is ${topLeft_1}`)
    
    for (let i = topLeft_0; i < topLeft_0+10; i++) {
        for (let j = topLeft_1; j < topLeft_1+10; j++) {
            // console.log(`for agent ${agent_id} : where i is ${i} and j is ${j}`)


            if (i >= data.size || i < 0 || j >= data.size || j < 0) {
                //out of bounds, just treat as an obstacle

                //obs_map[i-top_left[0],j-top_left[1]]=1
                obs_map = math.subset(obs_map, math.index(i-topLeft_0 , j-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : obs_map is ${obs_map}`)

                continue;
            }

            // console.log(`for agent ${agent_id} : data.state is ${data.state}`)
            // console.log(`for agent ${agent_id} : data.goals is ${data.goals}`)

            let dataState_ij = math.subset(data.state, math.index(i,j));
            // console.log(`for agent ${agent_id} : dataState_ij is ${dataState_ij}`)
            let dataGoals_ij = math.subset(data.goals, math.index(i,j));
            // console.log(`for agent ${agent_id} : dataGoals_ij is ${dataGoals_ij}`)
                
            if (dataState_ij == -1) {
                //obstacles

                //obs_map[i-top_left[0],j-top_left[1]]=1
                obs_map = math.subset(obs_map, math.index(i-topLeft_0 , j-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : obs_map is ${obs_map}`)

            }
                
            if (dataState_ij == agent_id) {
                //agent's position 
                
                //poss_map[i-top_left[0],j-top_left[1]]=1
                poss_map = math.subset(poss_map, math.index(i-topLeft_0 , j-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : poss_map is ${poss_map}`)
            }
                
            else if (dataGoals_ij == agent_id) {
                //agent's goal

                //goal_map[i-top_left[0],j-top_left[1]]=1
                goal_map = math.subset(goal_map, math.index(i-topLeft_0 , j-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : goal_map is ${goal_map}`)

            }

            if (dataState_ij > 0 && dataState_ij != agent_id) {
                //other agents' positions

                // poss_map[i-top_left[0],j-top_left[1]]=1
                poss_map = math.subset(poss_map, math.index(i-topLeft_0 , j-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : poss_map is ${poss_map}`)
                
                //visible_agents.append(data.state[i,j])   

                // console.log(`for agent ${agent_id} : (before if-else ...) visible_agents is ${visible_agents}`)

                if(math.deepEqual(visible_agents , math.matrix([[]])) ) {
                    // console.log(`for agent ${agent_id} : if(math.deepEqual(visible_agents , math.matrix([[]])) )`)
                    visible_agents  = math.matrix([dataState_ij]);
                    // console.log(`for agent ${agent_id} : visible_agents is ${visible_agents}`)

                } else {
                    // console.log(`for agent ${agent_id} : else ...`)
                    visible_agents = math.concat(visible_agents, [dataState_ij], 0);
                    // console.log(`for agent ${agent_id} : visible_agents is ${visible_agents}`)
                }
            }       
        }   
    }

    //dx=data.agent_goals[agent_id-1][0]-data.agent_positions[agent_id-1][0]
    let dx = math.subset(data.agent_goals, math.index(agent_id-1 , 0)) - math.subset(data.agent_positions, math.index(agent_id-1 , 0))
    // console.log(`for agent ${agent_id} : dx is ${dx}`)

    //dy=data.agent_goals[agent_id-1][1]-data.agent_positions[agent_id-1][1]
    let dy = math.subset(data.agent_goals, math.index(agent_id-1 , 1)) - math.subset(data.agent_positions, math.index(agent_id-1 , 1))
    // console.log(`for agent ${agent_id} : dy is ${dy}`)

    //mag=(dx**2+dy**2)**.5
    let mag = math.pow((math.pow(dx, 2) + math.pow(dy, 2)), .5)
    // console.log(`for agent ${agent_id} : mag is ${mag}`)


    if (mag != 0) {
        // console.log(`for agent ${agent_id} : if (mag != 0)`)

        //dx = dx/mag
        dx = dx/mag
        // console.log(`for agent ${agent_id} : dx is ${dx}`)

        //dy = dy/mag
        dy = dy/mag
        // console.log(`for agent ${agent_id} : dy is ${dy}`)

    }
        
    if (goals){
        // console.log(`for agent ${agent_id} : if (goals)`)

        //distance = lambda x1,y1,x2,y2 : ( (x2-x1)**2 +(y2-y1)**2)**.5
        let distance = (x1,y1,x2,y2) => math.pow((math.pow((x2-x1), 2) + math.pow((y2-y1), 2)), .5);
        // console.log(`for agent ${agent_id} : distance is ${distance}`)

        //for agent in visible_agents :

        let visible_agents_size = 0;
        if(!math.deepEqual(visible_agents , math.matrix([[]])) ){
            // console.log(`for agent ${agent_id} : for size visible_agents is ${visible_agents}`)
            visible_agents_size = math.subset(math.size(visible_agents), math.index(0));
            // console.log(`for agent ${agent_id} : visible_agents_size is ${visible_agents_size}`)
        }
        
        for (let i = 0; i < visible_agents_size; i++) {
            let agent = math.subset(visible_agents, math.index(i));
            // console.log(`for agent ${agent_id} : agent is ${agent}`)

            //x,y=data.agent_goals[agent-1]
            let x = math.subset(data.agent_goals, math.index(agent-1, 0));
            // console.log(`for agent ${agent_id} : x is ${x}`)
            let y = math.subset(data.agent_goals, math.index(agent-1, 1));
            // console.log(`for agent ${agent_id} : y is ${y}`)

            let topLeft_0 = math.subset(top_left, math.index(0));
            let topLeft_1 = math.subset(top_left, math.index(1));
            let bottom_right_0 = math.subset(bottom_right, math.index(0));
            let bottom_right_1 = math.subset(bottom_right, math.index(1));

            // console.log(`for agent ${agent_id} : topLeft_0 is ${topLeft_0}`)
            // console.log(`for agent ${agent_id} : topLeft_1 is ${topLeft_1}`)
            // console.log(`for agent ${agent_id} : bottom_right_0 is ${bottom_right_0}`)
            // console.log(`for agent ${agent_id} : bottom_right_1 is ${bottom_right_1}`)

            if (x < topLeft_0 || x >= bottom_right_0 || y >= bottom_right_1 || y < topLeft_1) {
            
                //out of observation
                
                //min_node=(-1,-1)
                let min_node = math.matrix([-1,-1])
                // console.log(`for agent ${agent_id} : min_node is ${min_node}`)

                //min_dist=1000
                let min_dist = 1000

                for (let i = topLeft_0; i < topLeft_0+10; i++) {
                    for (let j = topLeft_1; j < topLeft_1+10; j++) {
                        //d = distance(i,j,x,y)
                        let d = distance(i,j,x,y);
                        // console.log(`for agent ${agent_id} : d is ${d}`)

                        if (d < min_dist) {

                            //min_node=(i,j)
                            min_node = math.matrix([i,j])
                            // console.log(`for agent ${agent_id} : min_node is ${min_node}`)

                            min_dist = d
                            // console.log(`for agent ${agent_id} : min_dist is ${min_dist}`)

                        }
                    }
                }

                //goals_map[min_node[0]-top_left[0], min_node[1]-top_left[1]]=1
                let min_node_0 = math.subset(min_node, math.index(0))
                let min_node_1 = math.subset(min_node, math.index(1))
                // console.log(`for agent ${agent_id} : min_node_0 is ${min_node_0}`)
                // console.log(`for agent ${agent_id} : min_node_1 is ${min_node_1}`)
                goals_map = math.subset(goals_map, math.index(min_node_0-topLeft_0 , min_node_1-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : goals_map is ${goals_map}`)

            }
            else {
                //goals_map[x-top_left[0],y-top_left[1]]=1
                goals_map = math.subset(goals_map, math.index(x-topLeft_0 , y-topLeft_1), 1);
                // console.log(`for agent ${agent_id} : goals_map is ${goals_map}`)
            }
        }
        
        // console.log("poss_map : " + poss_map)
        // console.log("goal_map : " + goal_map)
        // console.log("goals_map : " + goals_map)
        // console.log("obs_map : " + obs_map)
        
        const matrix_1 = math.matrix([[poss_map,goal_map,goals_map,obs_map]]);
        // console.log(`for agent ${agent_id} : matrix_1 is ` + matrix_1);
        const matrix_2 = math.matrix([[dx,dy,mag]])
        // console.log(`for agent ${agent_id} : matrix_2 is ` + matrix_2);

        // console.log(`for agent ${agent_id} (if): [matrix_1, matrix_2] is ` + [matrix_1, matrix_2]);

        return [matrix_1, matrix_2] // Need check if can change to mathjs format

    }  
    else{
        // console.log("poss_map : " + poss_map)
        // console.log("goal_map : " + goal_map)
        // console.log("obs_map : " + obs_map)

        const matrix_1 = math.matrix([[poss_map,goal_map,obs_map]]);
        // console.log(`for agent ${agent_id} : matrix_1 is ` + matrix_1);
        const matrix_2 = math.matrix([[dx,dy,mag]])
        // console.log(`for agent ${agent_id} : matrix_2 is ` + matrix_2);

        // console.log(`for agent ${agent_id} : [matrix_1, matrix_2] is ` + [matrix_1, matrix_2]);

        return [matrix_1, matrix_2] // Need check if can change to mathjs format
    }
        
}

function getDir(data, action) {
    // console.log("getDir(data, action) data.dirDict[action] : " + data.dirDict[action])
    return data.dirDict[action];
}